import _ from 'lodash';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef,
  OnChanges,
  AfterViewInit,
  Inject
} from '@angular/core';
import { CampaignService } from '../../services/campaign.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { AuctionPresetOptionSchema } from '../../structure/auction';
import { ImageService } from 'app/core/services/image.service';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import { select, Store } from '@ngrx/store';
import { newAddCampaignPresetOption, newCreateCampaignPresetOption, newUpdateCampaignPresetOption } from '../../features/campaign.actions';
import { selectCampaignSelected } from '../../features/campaign.selectors';
import { AUCTION_TYPE, AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';
import { AccordionService, CampaignFormService, CampaignOptionFormService, CampaignOptionListService } from '../../services';
import { VideoProviderService } from '../../../event/services/video-provider.service';
import { MdbDropEvent, moveItemsInContainer } from 'mdb-angular-drag-and-drop';

import { QuillService } from 'app/core/services/quill.service';
import { ToastService } from 'app/toast/services/toast.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';
import { AUCTION_ACCORDION_SETTINGS_PRODVIDER, AUCTION_ACCORDION_SETTINGS_TOKEN, AUCTION_SETTINGS_TYPE } from 'app/campaign/tokens/auction.token';

@Component({
  selector: 'app-campaign-auction-option',
  templateUrl: './campaign-auction-option.component.html',
  styleUrls: ['./campaign-auction-option.component.scss'],
  providers: [
    AUCTION_ACCORDION_SETTINGS_PRODVIDER,
    {
      provide: AUCTION_SETTINGS_TYPE,
      useValue: 'presetOption',
    },
  ]
})
export class CampaignAuctionOptionComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() formGroupCampaignTypeData: any = null;
  @Input() selected: any = null;

  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  public AMOUNT_LIMIT = AMOUNT_LIMIT;
  
  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );
  public campaign = null;

  public videoProviderSelected = 0;
  public option: UntypedFormGroup = null;
  public additionalInfoSelect: UntypedFormControl = null;
  public additionalInfoSelectRequiredClassess = {
    'd-none': true
  };

  public defaultMinBid = 0;
  public defaultBidIncrement = 0;

  public value: any = null;

  public takeUntilSubject: Subject<any> = new Subject();
  public optionImages = [];
  public chooseImageModalShow = false;

  public imagesQueue = [];

  public optCategories = [];

  public position = 0;
  public cdkDragStartedPosition = 0;
  public cdkDragEndedPosition = 0;
  
  public quillOptions = {
    showToolbarList: false,
    size: 'sm'
  }

  public auctionStartTimeOptions: any = {
    dateFormat: 'mm/dd/yyyy'
  }
  public auctionEndTimeOptions: any = {
    dateFormat: 'mm/dd/yyyy'
  }

  constructor(
    public videoProviderService: VideoProviderService,
    private store: Store,
    private fb: UntypedFormBuilder,
    private campaignService: CampaignService,
    private campaignFormService: CampaignFormService,
    private imageService: ImageService,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    public campaignOptionListService: CampaignOptionListService,
    public quillService:QuillService,
    private toastService: ToastService,
    private chooseImageModalService: ChooseImageModalService,
    public accordionService: AccordionService,
    @Inject(AUCTION_ACCORDION_SETTINGS_TOKEN) private accordion,
    public campaignOptionFormService: CampaignOptionFormService,
  ) {}

  ngOnInit(): void {
    const { selected } = this;

    this.campaign$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(campaign => {
      this.campaign = campaign;
    });

    if (this.selected) {
      const imageUrl = selected.get('imageUrl').value !== '/images/blank_2x1.png' ? selected.get('imageUrl').value : null;
      selected.get('imageUrl').setValue(imageUrl);
      selected.get('imageDataUrl').setValue(imageUrl);

      const thumbnailUrl = selected.get('thumbnailUrl').value !== '/images/blank_1x1.png' ? 
        selected.get('thumbnailUrl').value 
        : '/images/blank_1x1.png';
      selected.get('thumbnailUrl').setValue(thumbnailUrl);
      selected.get('thumbnailDataUrl').setValue(thumbnailUrl);

      this.setImageValueByType(selected, 'image')
      this.setImageValueByType(selected, 'thumbnail')
      
      this.option = this.selected;

      if (!imageUrl) {
        this.optionImages = [...this.option.value.additionalImages];
      } else {
        this.optionImages = [imageUrl, ...this.option.value.additionalImages];
      }
      this.toggleChooseImageModal()

      this.value = _.cloneDeep(this.selected.value);
      this.videoProviderSelected = 0;
      if (this.option.get('videoProvider').value || this.option.get('videoProvider').value === 0) {
        this.videoProviderSelected = this.option.get('videoProvider').value;
      }

    } else {
      this.option = this.fb.group({});
      this.campaignService.generateForm(this.option, AuctionPresetOptionSchema);
    }

    this.defaultMinBid = this.option.get('minBid').value;
    this.defaultBidIncrement = this.option.get('bidIncrement').value;
    this.additionalInfoSelect = this.option.get('additionalInfoSelect') as UntypedFormControl;

    this.accordionService.map = {
      ...this.accordionService.map,
      ...this.accordion,
    };
    this.reNgOnInit();
    this.getOptionCategories();
  }

  ngAfterViewInit(): void {
    window['$']('[data-toggle="tooltip"]').tooltip(
      {
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    }
    )
  }

  reNgOnInit() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilSubject = new Subject();

    const additionalInfoSelectRequired = this.option.get('additionalInfoSelectRequired');
    this.additionalInfoSelectRequiredClassess['d-none'] = !additionalInfoSelectRequired.value;

    this.option.get('additionalImageFile').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const id = 'option-additional-image';
      if (value && value.length) {
        this.imagesQueue = value;
        this.uploadImages(id);

      } else {
        this.openCropperModal(value, id);
      }
    });

    this.option.get('additionalInfoRequired').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const additionalInfoDesc = this.option.get('additionalInfoDesc');
      const additionalInfoDetail = this.option.get('additionalInfoDetail');

      if(value) {
        additionalInfoDesc.setValue("");
        additionalInfoDetail.setValue("");

        additionalInfoDesc.clearValidators();
        additionalInfoDetail.clearValidators();

        additionalInfoDesc.setValidators([Validators.required]);

        additionalInfoDesc.updateValueAndValidity();
        additionalInfoDetail.updateValueAndValidity();
      } else {
        additionalInfoDesc.setValue("");
        additionalInfoDetail.setValue("");

        additionalInfoDesc.clearValidators();
        additionalInfoDetail.clearValidators();

        additionalInfoDesc.updateValueAndValidity();
        additionalInfoDetail.updateValueAndValidity();
      }
    });

    this.option.get('additionalInfoSelectRequired').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const additionalInfoSelectDesc = this.option.get('additionalInfoSelectDesc');
      const additionalInfoSelect = this.option.get('additionalInfoSelect');

      if(value) {
        additionalInfoSelectDesc.setValue("");
        additionalInfoSelect.setValue([]);

        additionalInfoSelectDesc.clearValidators();
        additionalInfoSelect.clearValidators();

        additionalInfoSelectDesc.setValidators([Validators.required]);
        additionalInfoSelect.setValidators([Validators.required]);

        additionalInfoSelectDesc.updateValueAndValidity();
        additionalInfoSelect.updateValueAndValidity();
      } else {
        additionalInfoSelectDesc.setValue("");
        additionalInfoSelect.setValue([]);

        additionalInfoSelectDesc.clearValidators();
        additionalInfoSelect.clearValidators();

        additionalInfoSelectDesc.updateValueAndValidity();
        additionalInfoSelect.updateValueAndValidity();
      }

      this.additionalInfoSelectRequiredClassess['d-none'] = !additionalInfoSelectRequired.value;
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'option-additional-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.cdr.markForCheck();
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'option-additional-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if (result === false) {
        const control = this.option.get('additionalImageDataUrls');
        const filtered = _.filter(control.value, (image, index) => {
          return index < control.value.length - 1;
        });
        control.setValue([...filtered]);
        this.optionImages = [...this.optionImages, ...filtered];
        this.toggleChooseImageModal()
      } else {
        if (result.imageUrl) {
          this.optionImages.push(result.imageUrl);
          this.toggleChooseImageModal()
        }
      }

      this.cdr.markForCheck();
    });

    this.option.get(`thumbnailFile`).valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      if(value == 'size error'){
        this.toastService.showDanger('The picture must be at least 200px by 200px.', {delay: 3000});
      }else{
        this.openCropperModal(value, `option-thumbnail`, 1/1)
      } 
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === `option-thumbnail`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.option.get(`thumbnailDataUrl`).setValue(result);

    });
    
    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === `option-thumbnail`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImageByType(`thumbnail`);
      } else {
        this.option.get(`thumbnailUrl`).setValue(result.imageUrl);
      }
      this.cdr.markForCheck();
    });


    const buyItNowEnabled = this.option.get('buyItNowEnabled');
    const buyItNowAmount = this.option.get('buyItNowAmount');

    this.option.get('buyItNowOnlyItem').valueChanges.pipe(
      filter(value => _.isEqual(value, true)),
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const minBid = this.option.get('minBid');
      minBid.clearValidators();
      minBid.setValue(0);

      const bidIncrement = this.option.get('bidIncrement');
      bidIncrement.clearValidators();
      bidIncrement.setValue(0);
      
      buyItNowEnabled.clearValidators();
      buyItNowEnabled.setValidators([Validators.requiredTrue]);
      buyItNowAmount.setValidators([Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]);
      
      if (buyItNowEnabled.value === false) {
        buyItNowEnabled.setValue(true, { emitEvent: false });
      }
      
      buyItNowEnabled.updateValueAndValidity({ emitEvent: false });
      buyItNowAmount.updateValueAndValidity({ emitEvent: false });
    });

    this.option.get('buyItNowOnlyItem').valueChanges.pipe(
      filter(value => _.isEqual(value, false)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const minBid = this.option.get('minBid');
      minBid.clearValidators();
      minBid.setValidators([Validators.required, Validators.min(1)]);

      const bidIncrement = this.option.get('bidIncrement');
      bidIncrement.clearValidators();
      bidIncrement.setValidators([Validators.required, Validators.min(1)]);

      if (!buyItNowEnabled.value) {
        buyItNowEnabled.clearValidators();
        buyItNowEnabled.setValidators([]);
        buyItNowEnabled.updateValueAndValidity({emitEvent: false });

        buyItNowAmount.setValidators([Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]);
        buyItNowAmount.updateValueAndValidity({emitEvent: false });
      }
    });

    this.option.get('buyItNowEnabled').valueChanges.pipe(
      filter(value => _.isEqual(value, true)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      buyItNowAmount.setValidators([Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]);
      buyItNowAmount.updateValueAndValidity({emitEvent: false });
    });
    
    this.option.get('buyItNowEnabled').valueChanges.pipe(
      filter(value => _.isEqual(value, false)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const currentBuyItNowAmount = buyItNowAmount.value;
      
      this.option.get('buyItNowOnlyItem').setValue(false, { emitEvent: false });

      buyItNowEnabled.clearValidators();
      buyItNowEnabled.setValidators([]);
      buyItNowEnabled.updateValueAndValidity({emitEvent: false });

      buyItNowAmount.setValidators([Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]);
      buyItNowAmount.updateValueAndValidity({emitEvent: false });
      
      setTimeout(() => {
        buyItNowAmount.setValue(currentBuyItNowAmount, { emitEvent: false });
      }, 0);
    });
    
    const optionStartDate = this.option.get("optionStartDate");
    const optionEndDate = this.option.get("optionEndDate");
    
    optionStartDate.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      optionEndDate.updateValueAndValidity();
    });

    optionEndDate.setValidators([function(control: AbstractControl) {
      const optionEndDateValue = control.value ? control.value: 0;
      const optionStartDateValue = optionStartDate.value ? optionStartDate.value: 0;
      if(optionEndDateValue === 0) {
        return null;
      }
      return optionStartDateValue > optionEndDateValue ? { incorrectDate: { value: optionEndDateValue } } : null;
    }]);

    this.campaignService.configGroup(this.option, this.option, {
      name: 'collectSalesTax',
      value: true
    }, [
      { name: 'salesTax', defaultValue: 0, validators: [Validators.required, Validators.min(0.01), Validators.max(100)] },
    ], this.takeUntilSubject);
  }

  ngOnChanges(changes: SimpleChanges) {
    const selected = _.get(changes, 'selected.currentValue', this.selected);
    if (selected) {
      const imageUrl = selected.get('imageUrl').value !== '/images/blank_2x1.png' ? selected.get('imageUrl').value : null;
      selected.get('imageUrl').setValue(imageUrl);
      selected.get('imageDataUrl').setValue(imageUrl);

      const thumbnailUrl = selected.get('thumbnailUrl').value !== '/images/blank_1x1.png' ? 
        selected.get('thumbnailUrl').value 
        : '/images/blank_1x1.png';
      selected.get('thumbnailUrl').setValue(thumbnailUrl);
      selected.get('thumbnailDataUrl').setValue(thumbnailUrl);

      this.option = this.selected;
      this.value = _.cloneDeep(this.selected.value);

      if (!this.selected.value.imageUrl) {
        this.optionImages = [...this.selected.value.additionalImages];
      } else {
        this.optionImages = [this.selected.value.imageUrl, ...this.selected.value.additionalImages];
      }
      this.toggleChooseImageModal()
    }

    if (this.option) {
      this.reNgOnInit();
    }
  }

  updateToolpips() {
    window['$']('[data-toggle="tooltip"]').tooltip('dispose');
    window['$']('[data-toggle="tooltip"]').tooltip(
      {
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' 
    }
    )
  }

  getOptionCategories() {
    this.campaignOptionListService.list.map((option) => {
      option.data.categories.forEach(element => {
        if (!this.optCategories.includes(element)){
          this.optCategories.push(element);
        }
      });
    });
  }

  toggleChooseImageModal() {
    if(this.optionImages.length !== 0 ) {
      this.chooseImageModalShow = false;
      window['$']('[data-toggle="tooltip"]').tooltip({
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' 
      })
    } else {
      this.chooseImageModalShow = true;
    }
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    this.optionImages = [];
  }

  uploadImages(id = 'option-additional-image') {
    if (!this.imagesQueue.length) {
      return;
    }

    this.imageService.cropper({
      id,
      images: this.imagesQueue
    });
  }

  onRemoveImage(index) {
    this.optionImages =  _.filter(this.optionImages, (image, imageIndex) => imageIndex !== index);

    const filtered = _.filter(this.optionImages, (image, idx) => {
      return idx !== 0;
    }) || null;

    if (filtered.length) {
      this.option.get('additionalImages').setValue(filtered);
    } else {
      this.option.get('additionalImages').setValue(null);
    }

    if (this.optionImages.length) {
      this.option.get('imageUrl').setValue(this.optionImages[0]);
    } else {
      this.option.get('imageUrl').setValue(null);
    }
    this.toggleChooseImageModal()
  }

  onCancel() {
    if (this.selected) {
      this.option.reset(this.value);
    }

    const buyItNowOnlyItem = this.option.get('buyItNowOnlyItem');
    if (_.isEqual(buyItNowOnlyItem.value, true)) {
      const minBid = this.option.get('minBid');
      minBid.setValue(0);
      minBid.clearValidators();
      minBid.setValidators([]);

      const bidIncrement = this.option.get('bidIncrement');
      bidIncrement.setValue(0);
      bidIncrement.clearValidators();
      bidIncrement.setValidators([]);
    }

    this.onChangeData.next(false);
  }

  saveCampaignOption() {
    const { campaign, option, selected, option: { value }  } = this;

    const name = option.get('name');
    const trimedName = _.trim(name.value);
    name.setValue(trimedName);

    if(option.invalid) {
      option.markAllAsTouched();
      this.campaignFormService.isNotValid();
      return false;
    }

    if (selected) {
      const imageUrl = this.optionImages[0] === '/images/blank_2x1.png' ? null : this.optionImages[0];
      selected.get('imageUrl').setValue(imageUrl);

      const thumbnailUrl = value.thumbnailUrl === '/images/blank_1x1.png' ? '' : value.thumbnailUrl;
      option.get('thumbnailUrl').setValue(thumbnailUrl);

      const filtered = _.filter(this.optionImages, (image, index) => {
        return index !== 0;
      }) || [];

      if (filtered.length) {
        this.option.get('additionalImages').setValue(filtered);
      } else {
        this.option.get('additionalImages').setValue(null);
      }

      const optionValue = this.campaignService.generateRequestObject(selected, AuctionPresetOptionSchema);

      this.store.dispatch({
        type: newUpdateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });

      return this.onCancel();
    } else {
      this.addCampaignOption();
    }
  }

  addCampaignOption() {
    let imageUrl = null;
    const { campaign, option, option: { value } } = this;

    if (this.optionImages.length) {
      imageUrl = this.optionImages[0];
      option.get('imageUrl').setValue(imageUrl);


      const filtered = _.filter(this.optionImages, (image, idx) => {
        return idx !== 0;
      }) || null;

      if (filtered.length) {
        option.get('additionalImages').setValue(filtered);
      } else {
        option.get('additionalImages').setValue(null);
      }
      this.toggleChooseImageModal()
    }

    const thumbnailUrl = value.thumbnailUrl === '/images/blank_1x1.png' ? '' : value.thumbnailUrl;
    option.get('thumbnailUrl').setValue(thumbnailUrl);

    const group = this.fb.group({});
    this.campaignService.generateForm(group, AuctionPresetOptionSchema);
    this.campaignService.initializeForm(group, this.option.value, AuctionPresetOptionSchema);

    option.reset();
    option.get('thumbnailUrl').setValue("/images/blank_1x1.png");
    const campaignId = _.get(campaign, 'id', null);
    const optionId = _.get(option, 'value.id', null);
    const optionValue = this.campaignService.generateRequestObject(group, AuctionPresetOptionSchema);

    if (_.isNull(campaignId)) {
      this.store.dispatch({
        type: newAddCampaignPresetOption.type,
        payload: { option: optionValue }
      });
      return this.onChangeData.next(true);
    }

    if (_.isNull(optionId)) {
      this.store.dispatch({
        type: newCreateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });
      return this.onCancel();
    }

    this.store.dispatch({
      type: newUpdateCampaignPresetOption.type,
      payload: { campaign, option: optionValue }
    });
    return this.onCancel();
  }

  openCropperModal(value, id, aspectRatio = 2/1) {
    const windowURL = window.URL || window.webkitURL;
    const url = windowURL.createObjectURL(value);
    this.imageService.cropper({
      url: this.domSanitizer.bypassSecurityTrustUrl(url),
      id: id,
      name: value.name,
      type: value.type,
      aspectRatio
    });
  }

  setImageValueByType(selected, type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    const url = selected.get(`${type}Url`).value === '/images/org_logo_default_v2.svg' ?
      `/images/blank_${ratio}.png`:
      selected.get(`${type}Url`).value;

    selected.get(`${type}DataUrl`).setValue(url);
    selected.get(`${type}Url`).setValue(url);
  }

  resetImageByType(type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    this.option.get(`${type}File`).setValue(null);
    this.option.get(`${type}DataUrl`).setValue(`/images/blank_${ratio}.png`);
    this.option.get(`${type}Url`).setValue(`/images/blank_${ratio}.png`);
  }

  getSoldAuction(){
    let soldCount =  this.option.get('soldCount').value
    let count = this.option.get('count').value
    if(soldCount){
       return `${soldCount} of ${count ? count : 0} sold.`;
    }else{
     return 'None sold yet.'
    }
   }

  isMultiple() {
    if (this.option instanceof UntypedFormGroup) {
      const count = this.option.get('count');
      return count.value > 1;
    }
    return false;
  }

  isSilentAuction() {
    const auctionType = this.formGroupCampaignTypeData.get('auctionType');
    return _.isEqual(AUCTION_TYPE.SILENT, auctionType.value);
  }

  resetVideoUrl() {
    this.option.get('videoUrl').setValue('');
    this.option.get('videoUrl').markAsUntouched();
  }

  onChangeDonatedBy(event) {
    if (!event.target.value) {
      this.option.get('displayDonatedBy').setValue(false);
    }
  }

  onChangeItemCode(event) {
    if (!event.target.value) {
      this.option.get('displayToDonors').setValue(false);
    }
  }

  onDrop(event: MdbDropEvent) {
    moveItemsInContainer(this.optionImages, event.previousIndex, event.newIndex);
  }

  openChooseImageModal(type = 0) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type, multiple: type === 0 });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        this.chooseImageModalService.modalRef = null;

        if(!imageUrl) {
          return;
        }
        const control = type === 0 ? 'image' : 'thumbnail';
        const hasAdditionalImages = this.option.get('additionalImages').value?.length > 0;

        if(control == 'image') {
          let firstImageUrl = imageUrl;
          
          if (Array.isArray(imageUrl)) {
            this.optionImages.push(...imageUrl);
            firstImageUrl = imageUrl[0];
          } else {
            this.optionImages.push(imageUrl);
          }

          if(!hasAdditionalImages) {
            this.option.get(`${control}DataUrl`).setValue(firstImageUrl);
            this.option.get(`${control}Url`).setValue(firstImageUrl);
          } 
        } else {
          this.option.get(`${control}DataUrl`).setValue(imageUrl);
          this.option.get(`${control}Url`).setValue(imageUrl);
        }

        this.toggleChooseImageModal();
        this.toastService.show('success', 'Added Successfully!', {delay: 2000});
      })
    })
  }

  generateThumbnail() {
    const imgUrl = this.option.get('imageUrl').value || '';
    if(imgUrl === "" || imgUrl === "/images/blank_2x1.png") {
      this.toastService.show('danger', 'Please upload an option image first.', {delay: 2500});
      return;
    }

    const params = {
      imageURL: imgUrl,
      width: 200
    }

    this.campaignService.generateThumbnail(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      const url = response.thumbnailURL || '/images/blank_1x1.png';

      this.option.get('thumbnailDataUrl').setValue(url);
      this.option.get('thumbnailUrl').setValue(url);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }

  generateSummary(summarySize = 0) {
    const description = this.option.get('desc').value || '';
    const summarySizeList = ['oneSentence', 'short', 'medium', 'long']

    if(description === "") {
      this.toastService.show('danger', 'Please add an option description first.', {delay: 2500});
      return;
    }

    const params = {
      text: description,
      summarySize: summarySizeList[summarySize]
    }

    this.campaignService.generateCSummary(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      this.option.get('summary').setValue(response.summary);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }
}
